(function () {
    'use strict';

    angular
        .module('harriApp')
        .service('hModalService', HModalService);

    function HModalService($modal) {
        var self = this;
        self.openModal = function (modalOptions, data) {
            var modal= {
                controller: 'hModalController',
                controllerAs: '$ctrl',
                templateUrl: '../hmodules/harri-main/controllers/h-modal.controller.html',
            };

            var modalData = (data.resolve.modalData || function () {
                return {};
            })();

            modalData.modalOptions = modalOptions;

            modal = angular.extend(modal, data);

            modal.resolve.onHide = data.resolve.onHide || function () {
                return function () {
                };
            };

            modal.resolve.onSave = data.resolve.onSave || function () {
                return function () {
                };
            };
            modal.resolve.onDelete = data.resolve.onDelete || function () {
                return function () {
                };
            };

            modal.resolve.modalData = function () {
                return modalData;
            };
            return $modal(modal);
        };
    }

    HModalService.$inject = ['$modal'];

})();